import React, { useEffect, useState } from "react";
import {Container, Image} from 'react-bootstrap';
import {Nav, Navbar,NavDropdown} from 'react-bootstrap';
import LOGO1 from '../assets/img/logo512.png'

function NavScrollExample() {
  const [exchangeRate, setExchangeRate] = useState(null);

  useEffect(() => {
    fetchExchangeRate();
  }, []);

  const fetchExchangeRate = async () => {
    try {
      const response = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
      const data = await response.json();
      const exchangeRate = data.rates.COP;
      setExchangeRate(exchangeRate);
    } catch (error) {
      console.log("Error fetching exchange rate:", error);
    }
  };

  return (
    <Navbar bg="light" expand="lg" className="shadow-lg mb-2">
      <Container fluid>
        <Navbar.Brand href="#"><Image alt="logo" fluid src={LOGO1} width="30" height="30"  className="d-inline-block align-top"></Image></Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            navbarScroll
          >
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="#AboutMe" className="page-scroll">Quien Soy</Nav.Link>
            <NavDropdown title="Productos y servicios" id="navbarScrollingDropdown">
              <NavDropdown.Item href="#Products">Productos</NavDropdown.Item>
              <NavDropdown.Item href="#action4">
               Servicios
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/Login">
               Login
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#contact">
              Contactenos
            </Nav.Link>
          </Nav>
          <div className="ms-auto d-flex align-items-center">
            <marquee direction="left" className="me-2" bgcolor="#F2F1EB">
              {exchangeRate ? `USD to COP: ${exchangeRate}` : "Loading..."}
            </marquee>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavScrollExample;
